import { render, staticRenderFns } from "./AccountUpdatedView.vue?vue&type=template&id=2f9bba3c&scoped=true&"
import script from "./AccountUpdatedView.vue?vue&type=script&lang=js&"
export * from "./AccountUpdatedView.vue?vue&type=script&lang=js&"
import style0 from "./AccountUpdatedView.vue?vue&type=style&index=0&id=2f9bba3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9bba3c",
  null
  
)

export default component.exports